module.exports = __webpack_public_path__ + "img/stop_rectangle.b833a13d.svg";